<template>
  <div>
    <div class="row">
      <div class="col s12">
        <div class="col s12 z-depth-1 white">
          <div class="row">
            <div style="padding-top: 10px;">
              <h5 class="title" style="padding-left: 11px;">{{ $t('analysis.switchOverview') }}</h5>
              <h6 style="padding-left: 11px;">{{ complexObject.ComplexName }}</h6>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <table class="summary-table noselect striped highlight">
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="month of months" :key="month">
                      {{ monthToString(month) }}
                    </th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="clickable" v-for="(item, index) of yearTableItems" :key="index">
                    <td @click="selectRailObjectId(item.railObjectId)" :class="{selected: selectedRailObject && selectedRailObject.RailObjectId === item.railObjectId}">{{ item.railObjectName }}</td>
                    <td v-for="month of months" :key="month" @click="selectRailObjectId(item.railObjectId, month)">
                      <div class="flex flex-col">
                        <div class="count-item">
                          {{ item[month] ? item[month].count : 0 }}
                          <i class="material-icons">call_split</i>
                        </div>
                        <div class="flex" v-if="item[month] && (item[month].warning || item[month].alarm)">
                          <div class="warning-text count-item" :class="{zero: !item[month].warning}">
                            {{ item[month].warning }}
                            <i class="material-icons">error</i>
                          </div>
                          <div class="alarm-text count-item" :class="{zero: !item[month].alarm}" style="margin-left: 5px">
                            {{ item[month].alarm }}
                            <i class="material-icons">warning</i>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td @click="selectRailObjectId(item.railObjectId)">
                      <div class="flex flex-col">
                        <div class="count-item">
                          {{ item.total.count }}
                          <i class="material-icons">call_split</i>
                        </div>
                        <div class="flex" v-if="item.total.warning || item.total.alarm">
                          <div class="warning-text count-item" :class="{zero: !item.total.warning}">
                            {{ item.total.warning }}
                            <i class="material-icons">error</i>
                          </div>
                          <div class="alarm-text count-item" :class="{zero: !item.total.alarm}" style="margin-left: 5px">
                            {{ item.total.alarm }}
                            <i class="material-icons">warning</i>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectedRailObject">
      <div class="col s12">
        <div class="col s12 z-depth-1 white">
          <div class="row">
            <div style="padding-top: 10px;">
              <h6 style="padding-left: 11px;">{{ selectedRailObject.Name }}</h6>
              <div class="col s2">
                <div class="input-field">
                  <select :value="selectedMonth" class="browser-default" @change="onMonthSelectionChanged">
                    <option v-for="month in months" :value="month" :key="month">
                      {{ monthToString(month) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <table class="summary-table noselect striped highlight">
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="day of days" :key="day">
                      {{ day }}
                    </th>
                    <th>Total</th>
                  </tr>
                  <tr v-if="Object.keys(monthTableTemperatures).length > 0">
                    <th>Min (°C)<br/>Max (°C)</th>
                    <th v-for="day of days" :key="day">
                      <template v-if="monthTableTemperatures[selectedMonth + day]">
                        {{ monthTableTemperatures[selectedMonth + day].minTemp }}
                        <br/>
                        {{ monthTableTemperatures[selectedMonth + day].maxTemp }}
                      </template>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr :class="{diffRow: item.direction === 'Diff'}" v-for="(item, index) of monthTableItems" :key="index">
                    <td>
                      {{ directionToString(item.direction) }}
                    </td>
                    <td v-for="day of days" :key="day">
                      <div v-if="item.direction === 'Diff'">
                        <div class="count-item" :class="{'zero': item[selectedMonth + day] === null, 'alarm-text': item[selectedMonth + day] < -1 || item[selectedMonth + day] > 1}">
                          {{ item[selectedMonth + day] || 0 }}
                          <i class="material-icons">call_split</i>
                        </div>
                      </div>
                      <div v-else class="flex flex-col">
                        <div class="count-item" :class="{zero: !item[selectedMonth + day] || !item[selectedMonth + day].count}">
                          {{ item[selectedMonth + day] ? item[selectedMonth + day].count : 0 }}
                          <i class="material-icons">call_split</i>
                        </div>
                        <div class="warning-text count-item" v-if="item[selectedMonth + day] && (item[selectedMonth + day].warning || item[selectedMonth + day].alarm)" :class="{zero: !item[selectedMonth + day].warning}">
                          {{ item[selectedMonth + day].warning }}
                          <i class="material-icons">error</i>
                        </div>
                        <div class="alarm-text count-item" v-if="item[selectedMonth + day] && item[selectedMonth + day].alarm">
                          {{ item[selectedMonth + day].alarm }}
                          <i class="material-icons">warning</i>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div v-if="item.direction === 'Diff'">
                        <div class="count-item">
                          {{ item.total || 0 }}
                          <i class="material-icons">call_split</i>
                        </div>
                      </div>
                      <div v-else class="flex flex-col">
                        <div class="count-item" :class="{zero: !item.total || !item.total.count}">
                          {{ item.total ? item.total.count : 0 }}
                          <i class="material-icons">call_split</i>
                        </div>
                        <span class="warning-text count-item" v-if="item.total && (item.total.warning || item.total.alarm)" :class="{zero: !item.total.warning}">
                          {{ item.total.warning }}
                          <i class="material-icons">error</i>
                        </span>
                        <div class="alarm-text count-item" v-if="item.total && item.total.alarm">
                          {{ item.total.alarm }}
                          <i class="material-icons">warning</i>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import SwitchApi from '../../../services/api/switch/SwitchApi'
import RailObjectService from '../../../services/RailObjectService'
import AuthenticationService from '../../../services/AuthenticationService'

export default {
  name: 'SwitchOverviewAnalysis',
  props: {
    complexObject: {},
    timeSelection: {}
  },
  data () {
    return {
      yearTableItems: [],
      monthTableItems: [],
      monthTableTemperatures: {},
      selectedRailObject: null,
      selectedMonth: null,
      months: [],
      days: [],
      showYear: false,
      showDiff: false
    }
  },
  mounted: function () {
    const systemRoleId = AuthenticationService.getUser().SystemRoleId
    this.showDiff = systemRoleId === 2 || systemRoleId === 3
  },
  created: async function () {
    await this.load()
  },
  methods: {
    load: async function () {
      this.months = []
      this.yearTableItems = []

      const dtFrom = moment(this.timeSelection.start).startOf('day')
      const dtTo = moment(this.timeSelection.end).endOf('day')
      this.showYear = dtFrom.year() !== dtTo.year()
      var interim = dtFrom.clone()
      // eslint-disable-next-line no-unmodified-loop-condition
      while (dtTo > interim || interim.format('M') === dtTo.format('M')) {
        this.months.push(interim.format('YYYYMM'))
        interim.add(1, 'month')
      }

      const yearResult = (await SwitchApi.getComplexMeasurementDataSummary(this.complexObject.ComplexId, dtFrom.format('YYYY-MM-DDTHH:mm:ss'), dtTo.format('YYYY-MM-DDTHH:mm:ss'))).data
      for (const result of yearResult) {
        var yearTableItem = this.yearTableItems.find(i => i.railObjectId === result.RailObjectId)
        if (!yearTableItem) {
          const railObject = RailObjectService.getRailObjectByRailObjectId(result.RailObjectId)
          yearTableItem = {
            railObjectId: result.RailObjectId,
            railObjectName: railObject.Name,
            total: {
              count: 0,
              warning: 0,
              alarm: 0
            }
          }
          this.yearTableItems.push(yearTableItem)
        }
        yearTableItem[result.Date] = {
          count: result.Count,
          warning: result.CountWarning,
          alarm: result.CountAlarm
        }
        yearTableItem.total.count += result.Count
        yearTableItem.total.warning += result.CountWarning
        yearTableItem.total.alarm += result.CountAlarm
      }
    },
    loadMonthData: async function () {
      const dtFrom = moment.max(moment(this.selectedMonth, 'YYYYMM').startOf('month'), moment(this.timeSelection.start).startOf('day')).format('YYYY-MM-DDTHH:mm:ss')
      const dtTo = moment.min(moment(this.selectedMonth, 'YYYYMM').endOf('month'), moment(this.timeSelection.end).endOf('day')).format('YYYY-MM-DDTHH:mm:ss')

      this.monthTableItems = []
      this.monthTableTemperatures = {}

      const monthResult = (await SwitchApi.getRailObjectMeasurementDataSummary(this.selectedRailObject.RailObjectId, dtFrom, dtTo)).data
      for (const result of monthResult) {
        var monthTableItem = this.monthTableItems.find(i => i.direction === result.Direction)
        if (!monthTableItem) {
          monthTableItem = {
            direction: result.Direction,
            total: {
              count: 0,
              warning: 0,
              alarm: 0
            }
          }
          this.monthTableItems.push(monthTableItem)
        }
        monthTableItem[result.Date] = {
          count: result.Count,
          warning: result.CountWarning,
          alarm: result.CountAlarm
        }
        monthTableItem.total.count += result.Count
        monthTableItem.total.warning += result.CountWarning
        monthTableItem.total.alarm += result.CountAlarm

        if (!this.monthTableTemperatures[result.Date]) {
          if (result.MinTemperature !== null || result.MaxTemperature !== null) {
            this.monthTableTemperatures[result.Date] = { minTemp: result.MinTemperature, maxTemp: result.MaxTemperature }
          }
        } else {
          this.monthTableTemperatures[result.Date].minTemp = this.monthTableTemperatures[result.Date].minTemp === null
            ? result.MinTemperature
            : (result.MinTemperature === null ? this.monthTableTemperatures[result.Date].minTemp : Math.min(this.monthTableTemperatures[result.Date].minTemp, result.MinTemperature))
          this.monthTableTemperatures[result.Date].maxTemp = this.monthTableTemperatures[result.Date].maxTemp === null
            ? result.MaxTemperature
            : (result.MaxTemperature === null ? this.monthTableTemperatures[result.Date].maxTemp : Math.max(this.monthTableTemperatures[result.Date].maxTemp, result.MaxTemperature))
        }
      }

      if (this.showDiff) {
        const diff = {
          direction: 'Diff'
        }

        for (const day of this.days) {
          const normal = this.monthTableItems[0][this.selectedMonth + day] ? this.monthTableItems[0][this.selectedMonth + day].count : 0
          const reverse = this.monthTableItems[1][this.selectedMonth + day] ? this.monthTableItems[1][this.selectedMonth + day].count : 0
          diff[this.selectedMonth + day] = this.monthTableItems[0][this.selectedMonth + day] === undefined && this.monthTableItems[1][this.selectedMonth + day] === undefined ? null : normal - reverse
        }

        diff.total = this.monthTableItems[0].total.count - this.monthTableItems[1].total.count

        this.monthTableItems.push(diff)
      }
    },
    selectRailObjectId: async function (railObjectId, month) {
      const newMonth = month || this.months[0]
      if (this.selectedRailObject && this.selectedRailObject.RailObjectId === railObjectId && this.selectedMonth === newMonth) {
        return
      }
      this.selectedRailObject = RailObjectService.getRailObjectByRailObjectId(railObjectId)
      this.setSelectedMonth(newMonth)

      await this.loadMonthData()
    },
    onMonthSelectionChanged: async function (event) {
      const month = event.target.value
      if (this.selectedMonth === month) {
        return
      }

      this.setSelectedMonth(month)

      await this.loadMonthData()
    },
    setSelectedMonth: function (month) {
      if (this.selectedMonth === month) {
        return
      }

      this.selectedMonth = month

      this.days = []
      const dayStart = this.selectedMonth === moment(this.timeSelection.start).format('YYYYMM') ? moment(this.timeSelection.start).date() : 1
      const dayEnd = this.selectedMonth === moment(this.timeSelection.end).format('YYYYMM') ? moment(this.timeSelection.end).date() : new Date(this.selectedMonth.substring(0, 4), this.selectedMonth.substring(4, 6), 0).getDate()
      for (let i = dayStart; i <= dayEnd; i++) {
        this.days.push(i.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}))
      }
    },
    directionToString: function (direction) {
      switch (direction) {
        case 0:
          return 'Normal'
        case 1:
          return 'Reverse'
        default:
          return direction
      }
    },
    monthToString: function (month) {
      const monthPart = month.substring(4, 6)
      let result = ''
      switch (monthPart) {
        case '01':
          result += this.$t('months.long.january')
          break
        case '02':
          result += this.$t('months.long.february')
          break
        case '03':
          result += this.$t('months.long.march')
          break
        case '04':
          result += this.$t('months.long.april')
          break
        case '05':
          result += this.$t('months.long.may')
          break
        case '06':
          result += this.$t('months.long.june')
          break
        case '07':
          result += this.$t('months.long.july')
          break
        case '08':
          result += this.$t('months.long.august')
          break
        case '09':
          result += this.$t('months.long.september')
          break
        case '10':
          result += this.$t('months.long.october')
          break
        case '11':
          result += this.$t('months.long.november')
          break
        case '12':
          result += this.$t('months.long.december')
          break
      }

      if (this.showYear) {
        result += ' ' + month.substring(0, 4)
      }

      return result
    }
  },
  watch: {
    timeSelection () {
      this.selectedRailObject = null
      this.load()
    }
  }
}
</script>

<style scoped>
.summary-table thead tr {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.summary-table th,
.summary-table td {
  padding: 5px 5px;
  text-align: left;
  vertical-align: top;
}

.diffRow {
  border-top: 1px solid rgba(0, 0, 0, 0.2)
}

.count-item {
  display: inline-block;
}

.count-item i {
  vertical-align: bottom;
}

.selected {
  font-weight: bold;
}

.flex {
  display: flex!important;
}

.flex-col {
  flex-direction: column!important;
}

.zero {
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/SwitchOverviewAnalysis.vue